const isNumber = (value) => typeof value === "number";

export { isNumber };
